import type { EstimationConfig } from '../../../model/types';

export const FETCH_ESTIMATION_CONFIG =
	'state.actions.estimation-config.FETCH_ESTIMATION_CONFIG' as const;

export type FetchEstimationConfig = {
	type: typeof FETCH_ESTIMATION_CONFIG;
};

export const fetchEstimationConfig = (): FetchEstimationConfig => ({
	type: FETCH_ESTIMATION_CONFIG,
});

export const FETCH_ESTIMATION_CONFIG_SUCCESS =
	'state.actions.estimation-config.FETCH_ESTIMATION_CONFIG_SUCCESS' as const;

export type FetchEstimationConfigSuccess = {
	type: typeof FETCH_ESTIMATION_CONFIG_SUCCESS;
	readonly payload: EstimationConfig;
};

export const fetchEstimationConfigSuccess = (
	payload: EstimationConfig,
): FetchEstimationConfigSuccess => ({
	type: FETCH_ESTIMATION_CONFIG_SUCCESS,
	payload,
});

export const FETCH_ESTIMATION_CONFIG_FAILURE =
	'state.actions.estimation-config.FETCH_ESTIMATION_CONFIG_FAILURE' as const;

export type FetchEstimationConfigFailure = {
	type: typeof FETCH_ESTIMATION_CONFIG_FAILURE;
};

export const fetchEstimationConfigFailure = (): FetchEstimationConfigFailure => ({
	type: FETCH_ESTIMATION_CONFIG_FAILURE,
});

export type Action =
	| FetchEstimationConfig
	| FetchEstimationConfigSuccess
	| FetchEstimationConfigFailure;
